import "./implementation-contract";
import "./registry-contract";
import { InjectorDecorator } from "./injector-decorator";
import { ActionRegistryImplementation } from "./registry";
import { AgentActionRouteController } from "./route-hoster";
import { actionTriggerDirective } from "./trigger";

let agentActionModule = angular
  .module("sdApp.agentAction", [])
  .directive("aafActionTrigger", actionTriggerDirective)
  .service("actionRegistryService", ActionRegistryImplementation)
  .controller("AgentActionRouteController", AgentActionRouteController)
  .component("sdAgentActionRouteHost", {
    controller: AgentActionRouteController,
    template: `<div class="agent-action-route-host"></div>`
  })
  .run(InjectorDecorator);
export default agentActionModule;
